<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-test="back-arrow-icon" data-testid="back-arrow-icon">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div  class="header-text">CLEARING HOUSE REPORT</div>
  </div>
  @if (!isContentReady) {
    <div class="content">
      <app-dqf-document-skeleton></app-dqf-document-skeleton>
    </div>
  }
  <div class="content" [ngClass]="{ 'hide-content': !isContentReady }">
    <app-upload-document 
      [formUploadFiles]="formUploadFiles" 
      [documentDqfStatus]="documentStatus"
      (uploadDocument)="uploadDocument()" 
      (deleteDocument)="deleteDocument()"
      (requestCarrier)="requestCarrierToUploadDocument()"
      [documentType]="documentType"
      [hideTabs]="false"
    ></app-upload-document>
  </div>
</div>